import { useNotificationsHubStore } from 'dashboard/stores/notificationsHub';
import { MESSAGE_TYPE } from 'shared/constants/messages';

// Bridge real-time chat events (ActionCable message.created) into the
// Notifications Hub. Everything that qualifies is logged; the browser/OS
// notification only fires when the conversation is assigned to the logged-in
// Dotchat user (handled by the store via targetUserIds + currentUserId).
export const logChatNotification = (data, vuexStore) => {
  // Only an incoming customer message counts as a "new chat" event;
  // ignore agent replies, activity lines and private notes.
  if (data?.message_type !== MESSAGE_TYPE.INCOMING) return;
  if (data?.private) return;

  const hub = useNotificationsHubStore();
  // The message.created payload carries conversation.assignee_id directly, so
  // we don't depend on the conversation being in the agent's store yet.
  const conversationId = data.conversation_id;
  const assigneeId = data.conversation?.assignee_id ?? null;
  const senderName = data.sender?.name || 'Contacto';

  const content = (data.content || '').toString();
  const snippet = content.length > 80 ? `${content.slice(0, 80)}…` : content;

  // Keep the hub aware of who is logged in so it can gate the browser alert.
  hub.setCurrentUser(vuexStore.getters.getCurrentUserID);

  hub.log({
    category: 'chat',
    action: 'message',
    title: `Nuevo mensaje de ${senderName}`,
    body: snippet || `Conversación #${conversationId}`,
    executor: { type: 'contact', name: senderName, id: data.sender?.id },
    targetUserIds: assigneeId ? [assigneeId] : [],
    meta: { conversationId, messageId: data.id },
  });
};
